import { Stack } from '@mui/material';

import AuthInfoAchievement from '@/shared/assets/images/auth/auth-info-achievements.png';

import { QUOTES } from '../Quote/constants';
import { Quote } from './Quote';
import { SImage, SQuoteContainer } from './styled';

export const ReviewsInfo = () => {
  return (
    <Stack gap={30}>
      <SImage alt="achievements info" src={AuthInfoAchievement} />
      <SQuoteContainer direction="row" gap={12}>
        <Quote {...QUOTES[1]} />
        <Quote {...QUOTES[6]} />
      </SQuoteContainer>
    </Stack>
  );
};
